export enum TagTypesPrefix {
  status = '#',
  department = '@',
  stakeholder = '§',
  remaining = '',
}
